export enum SubCourseActionTypes {
    API_RESPONSE_SUCCESS = "@@sub_course/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@sub_course/API_RESPONSE_ERROR",
  
    CREATE_SUB_COURSE = "@@sub_course/CREATE_SUB_COURSE",
    GET_SUB_COURSE = "@@sub_course/GET_SUB_COURSE",
    UPDATE_SUB_COURSE = "@@sub_course/UPDATE_SUB_COURSE",
    DELETE_SUB_COURSE = "@@sub_course/DELETE_SUB_COURSE",
  }